import React from 'react'

const Fb = () => {
    return (
        <div className='fb-container'>
            <div className='fb-header'>
                <h1>Hệ thống đang cập nhật </h1>

            </div>
        </div>
    )
}

export default Fb